import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import { withRouter } from 'react-router';

import * as routes from '../../constants/routes';
import * as queries from '../../constants/queries';


function compare(a,b) {
  if(a.name < b.name)
    return -1;
  if(a.name > b.name)
    return 1;
  return 0;
}


// import withAuthorization from './auth/withAuthorization';


class propertySearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      citySearch: 'none',
    };
  }

  render() {
    return (
      <div className="be-content">
        <Query query={queries.GET_ALL_COMMUNITIES_FIND_A_COMMUNITY} pollInterval={0}>
          {({data, loading, error}) => {
            if (error) return <h1>Error...</h1>
            if (loading) return <h1>Loading...</h1>

            var sortedCommunities = [...data.getAllCommunitiesFindACommunity];
            // sortedCommunities.filter(searchPropertyName, this.state.propertyNameSearch);
            sortedCommunities.sort(compare);
            var cities = [...new Set(sortedCommunities.map(property => property.propertyPhysicalAddressCity + ", " + property.propertyPhysicalAddressState))];
            cities.sort();
            cities.shift();
            console.log(sortedCommunities);

            return (
              <div className="main-content container-fluid">
                <h3 className="text-center">Property Search page</h3>
                <select className="form-control" value={this.state.citySearch} onChange={(e) => {this.setState({citySearch: e.target.value})}}>
                  <option value="none">Select City</option>
                  {cities.sort().map(function(city, index){
                    return (
                      <option value={city} key={index}>{city}</option>
                    )
                  })}
                </select>
                <br />
                <br />
                <div className="row">
                  {sortedCommunities.map(function(community, index){
                    var truthTest = true
                    var propertyImages = community.images.values;
                    var showPic = false;
                    var mainPic = "http://images.winternet.work/Errors/NoImage.png";
                    if(community.images.length > 0){
                      showPic = true;
                      mainPic = "http://images.winternet.work/" + community.id + "/" + community.images[0];
                    }
                    console.log(mainPic);

                    if(this.state.citySearch !== "none"){
                      if(community.propertyPhysicalAddressCity){
                        var stringSplit = this.state.citySearch.split(", ");
                        var city = stringSplit[0];
                        var state = stringSplit[1];
                        if(community.propertyPhysicalAddressCity.indexOf(city) != -1){

                        } else {
                          truthTest = false;
                        }
                      }else{
                        truthTest = false;
                      }
                    }
                    if(truthTest) {
                      return (
                        <div key={index}>
                          <div className="col-lg-4 searchCommunityEntity">
                            <div className="panelPropSearch panel-border-color panel-border-color-success">
                              <div className="row">
                                <div className="panel-heading col-lg-12">{community.name}</div>
                              </div>

                              <div className="panel-body">
                                <div className="row">
                                  <div className="col-sm-6">
                                    <div>
                                    <b>Address</b><br />
                                    {community.propertyPhysicalAddressLine1} <br />
                                    {community.propertyPhysicalAddressCity}, {community.propertyPhysicalAddressState} {community.propertyPhysicalAddressZipCode}
                                   </div>
                                   <br />
                                   <div>
                                     <b>Email</b><br />
                                     {community.emailAddress}
                                   </div><br />
                                   <div>
                                     <b>Phone Number(s)</b><br />
                                     {community.officePhoneNumbers.map(function(phone, index2){
                                       return(<div key={index2}>
                                         {phone}
                                       </div>)
                                     })}
                                   </div><br />
                                   <div>
                                     <b>Fax Number</b><br />
                                     {community.faxNumber}
                                   </div>
                                  </div>
                                  <div className="col-sm-6">
                                      <img className="PropPic" src={mainPic} alt=""/>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    }
                  }, {history: this.props.history, state: this.state})}
                </div>
              </div>
            )
          }}
        </Query>
      </div>
    );
  }
}


// const authCondition = (authUser) => !!authUser;
export default propertySearch;
// export default withAuthorization(authCondition)(HomePage);



// WEBPACK FOOTER //
// ./src/components/propertySearch/propertySearch.js